<template>
	<el-container>
		<el-main style="width: 70%;">
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">登录设备管理</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<!--设备列表-->
			<el-table :data="tableData" border highlight-current-row :max-height="maxHeight()" stripe
				v-loading="diaLoading">
				<el-table-column property="loginName" label="客服"></el-table-column>
				<el-table-column property="equipmentId" label="设备号"></el-table-column>
				<el-table-column property="os" label="最近登录设备"></el-table-column>
				<el-table-column label="最近登录IP/城市">
					<template slot-scope="scope">
						{{scope.row.ip}}/{{scope.row.city}}
					</template>
				</el-table-column>
				<el-table-column property="loginTime" label="最近登录时间"></el-table-column>
				<el-table-column property="count" label="锁定设备(0)"></el-table-column>
				<el-table-column property="operate" label="操作" width="150" fixed="right">
					<template slot-scope="scope">
						<div style="display: flex;flex-direction: row;justify-content: space-around;">
							<el-button type="text" size="small" @click="showAll(scope.row)" class="item_font">锁定设备
							</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog title="锁定设备" :visible.sync="addQuery" custom-class="dialog" :close-on-click-modal="false"
				:close-on-press-escape="false" width="600px" center>
				<el-table ref="multipleTable" :data="tableData2" border style="width: 100%"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="equipmentId" label="设备号"></el-table-column>
					<el-table-column prop="os" label="登录设备"></el-table-column>
					<el-table-column prop="status" label="设备状态">
						<template slot-scope="scope">
							<span v-show="scope.row.status == 1">已锁定</span>
							<span v-show="scope.row.status == 0">未锁定</span>
						</template>
					</el-table-column>
					<el-table-column label="最近登录IP/城市">
						<template slot-scope="scope">
							{{scope.row.ip}}/{{scope.row.city}}
						</template>
					</el-table-column>
					<el-table-column prop="loginDate" label="最近登录时间"></el-table-column>
				</el-table>
				<div style="text-align: center;margin-top: 10px;">
					<el-button @click="addQuery = false" size="mini">取 消</el-button>
					<el-button type="primary" @click="sureLock" size="mini">锁定设备</el-button>
				</div>
			</el-dialog>
		</el-main>
	</el-container>
</template>

<script>
	import {
		maxHeight
	} from '../../utils/tableHeight'
	export default {
		data() {
			return {
				diaLoading: true,
				tableData: [],
				total: 0,
				tableData2: [],
				addQuery: false,
				multipleSelection: [],
				csId: '',
			}
		},

		created() {},

		mounted() {
			this.getAdmList();
		},

		methods: {
			maxHeight,
			async getAdmList() {
				var api = "/manager/equipment/selectCsEquipments";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {},
				});
				console.log("*****querySelect *****", response);
				if (response.resultCode == 10000) {
					this.diaLoading = false;
					this.tableData = response.data;
				} else {
					this.diaLoading = false;
					this.$message.error(response.desc);
				}
			},
			showAll(row) {
				this.multipleSelection = [];
				this.getEquList(row.csId);
				this.csId = row.csId;
			},
			//获取该客服的所有设备
			async getEquList(val) {
				var api = "/manager/equipment/adminSelectCsEquipments?csId=" + val;
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {},
				});
				console.log("*****querySelect *****", response);
				if (response.resultCode == 10000) {
					this.tableData2 = response.data;
					this.addQuery = true;
				} else {
					this.diaLoading = false;
					this.$message.error(response.desc);
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			sureLock() {
				if (this.multipleSelection.length == 0) {
					this.$message.warning("请先选择设备");
					return;
				}
				this.lockItem();
			},
			async lockItem() {
				var equipmentIds = [];
				for (var i = 0; i < this.multipleSelection.length; i++) {
					equipmentIds.push(this.multipleSelection[i].equipmentId);
				}
				var api = "/manager/equipment/lockEquipment";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						csId: this.csId,
						equipmentIds: equipmentIds
					},
				});
				console.log("*****querySelect *****", response);
				if (response.resultCode == 10000) {
					console.log(response.data);
					this.$message.success("锁定成功");
					this.addQuery = false;
					this.csId = '';
					this.multipleSelection = [];
				} else {
					this.diaLoading = false;
					this.$message.error(response.desc);
				}
			},
		}
	}
</script>

<style scoped="scoped">
	.custom_div {
		margin-bottom: 0.9375rem;
	}

	.custom_div>span {
		font-size: 0.875rem;
		color: #444444;
	}

	.talkListBox {
		width: 100%;
		overflow: hidden;
	}

	.talkListBox dl {
		overflow: hidden;
		margin-bottom: 10px;
	}

	.talkListBox dl dt {
		width: 100%;
		height: 30px;
		background: #eee;
		padding: 0 20px;
		box-sizing: border-box;
		font-size: 14px;
		line-height: 30px;
		font-weight: bold;
		color: darkgreen;
	}

	.talkListBox dl dd.active {
		background: #f5f5f5;
	}

	.talkListBox dl dd {
		padding: 5px 20px;
		overflow: hidden;
		font-size: 13px;
		line-height: 25px;
		font-weight: normal;
		border-bottom: 1px #ddd dotted;
	}

	.talkListBox dl dd .title {
		color: #5A9CF8;
		font-weight: normal;
	}

	.talkListBox dl dd .log {
		color: blue;
	}
</style>
